<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">认证权限 /</div>
        <div class="box-header-right"><div>日志管理</div></div>
      </div>
    </div>
    <div class="section">
      <div class=" biaodan">
        <div class="botton-box"></div>
        <div class="biaodan-left">
          <div style="height: 100%">
            <el-form
              :inline="true"
              label-position="right"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="模块名称">
                <el-input
                  v-model="form.title"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入模块名称"
                ></el-input>
              </el-form-item>

              <el-form-item class="form-item">
                <el-button
                  type="primary"
                  @click="onSearch"
                  class="search"
                  size="mini"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  @click="onReset"
                  class="search"
                  size="mini"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              :data="tableData"
              align="center"
              max-height="600"
              :header-cell-style="{
                background: '#F3F8FE',
                color: '#333333 ',
                textAlign: 'center'
              }"
              :cell-style="{ textAlign: 'center' }"
            >
              <el-table-column
                label="模块名称"
                prop="title"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="操作状态"
                prop="status"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="业务类型"
                prop="businessType"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="请求时间"
                prop="operTime"
                show-overflow-tooltip
              ></el-table-column>

              <el-table-column
                label="操作人"
                prop="operName"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination
            :style="{ textAlign: 'right', marginTop: '20px' }"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLogList } from "@/api/logManagement";
export default {
  data() {
    return {
      tableData: [],
      page: {
        page: 1,
        size: 10
      },
      form: {
        title: "",
        userName: ""
      },
      currentPage: 1,
      total: null
    };
  },
  mounted() {
    this.getLogList();
  },
  methods: {
    // 获取日志列表
    async getLogList() {
      let params = {
        page: this.page.page,
        size: this.page.size,
        query: {}
      };
      if (this.form.title) {
        params.query.title = this.form.title;
      }
      if (this.form.userName) {
        params.query.userName = this.form.userName;
      }
      const res = await getLogList(params);
      this.tableData = res.data.data.records || [];
      this.total = Number(res.data.data.total) || null;
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.Size = 10;
      this.getLogList();
    },
    onReset() {
      this.form.title = "";
      this.form.userName = "";
      this.onSearch();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getLogList();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getLogList();
    }
  }
};
</script>
<style scoped lang="less">
.box-father {
  height: 100%;
  width: 100%;
  padding: 0px 20px 20px 20px;
  background-color: #fff;
}

.box-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
}

.box-header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.box-header-left-text {
  width: 120px;
  height: 14px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #b2b3c9;
  line-height: 21px;
  display: flex;
  align-items: center;
}

.box-header-right {
  font-weight: 400;
  color: #004ad1;
  line-height: 21px;
  width: 90%;
  height: 81%;
  margin-top: 3px;
  display: flex;
  align-items: center;
}

.section {
  height: 94.9%;
  background-color: #fff;
}

.el-menu-item.is-active {
  background: rgb(59, 121, 203, 0.2) !important;
}

.el-menu-item:hover {
  color: #1e90ff;
}

.daohang {
  display: flex;
  margin-left: 15px;
}

.daohang .el-menu-item {
  width: 100px;
  margin-left: 20px;
}

.biaodan {
  width: 100%;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 70px;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.biaodan-left .el-form-item {
  margin-bottom: 0px;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  //align-items: center;
  justify-content: space-between;
}

.export {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

/* .aside{
  height: 100%;
}
.disTable{
  height: 100%;
} */
.element.style {
  height: 570px;
}

/* .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 -28px !important;
} */
///deep/ .el-tabs__item {
//  height: 45px !important;
//  margin-top: 15px;
//}
.form-box {
  width: 100%;
  //display: flex;
  //flex-wrap: wrap;
  margin-top: 10px;
}

.form-content {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.form-item {
  display: flex;
  justify-content: left;
}

.form-content-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/ ::-webkit-scrollbar-thumb {
  background-color: #dbdde3;
  border-radius: 5px;
}

.botton-box {
  width: 20%;
  height: 50px;
  display: flex;
  align-items: center;
}

.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}

//.el-form--inline .el-form-item__content {
//  width: 70%;
//}
.section .el-form-item__label {
  text-align: left;
}

.addValueDialog .el-form--inline .el-form-item {
  width: 100%;
}

.black {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

/deep/ .el-dialog__wrapper .addValueDialog .el-form-item__label {
  width: 130px !important;
}

.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}

.passWordForm {
  .el-form-item__content {
    width: 70%;
    display: flex !important;
    justify-content: space-between;
    align-items: baseline;
    margin-top: -43px;
    margin-left: 95px;
  }
}

.updatePassword {
  width: 70px;
  height: 36px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background: #0495FF;
  border-radius: 10%;
}

#character {
  .el-dialog {
    height: 860px;
    overflow: scroll;
  }

  .el-form-item__label {
    width: 95px;
  }

  .Permission_form {
    display: flex;
    justify-content: space-around;

    .roleLabel {
      color: #606266;
      font-size: 14px;
      font-weight: 800;
    }

    .el-form-item__content {
      width: 78.5%;
      height: 45px;
    }
  }

  .div-tag {
    width: auto;
    display: inline-block;
    position: relative;
    bottom: 41px;
    left: 4px;
    height: 40px;
    max-width: 450px;
    overflow-y: hidden;
    overflow-x: scroll;
    white-space: nowrap;
  }

  .test-1::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }

  .test-1::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }

  .character .el-dialog__body .data-d {
    height: 345px;
  }

  .pass {
    .el-dialog {
      margin-top: 33vh !important;
      width: 23% !important;
      height: 433px !important;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
  }
}

/deep/.v-modal {
  z-index: 2000 !important;
}

.user-dialog {
  .el-form-item {
    margin-bottom: 10px;
    width: 45% !important;
  }
}

.character .el-dialog__body form {
  padding-bottom: 0;
}

.tree-option {
  height: auto;
}

.tree-class .el-tree-node__content {
  &:hover {
    background-color: #dfeafb;
  }
}

.el-message {
  z-index: 2222 !important;
}

.tree-d {
  .el-form-item__content {
    position: relative;

    & > .el-input {
      position: absolute;
      z-index: 2;
    }
  }
}

.word {
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    margin-left: 25px;
  }
}

.guanlian {
  margin-left: 88px;
}

///deep/ .table_name {
//  table {
//    tbody {
//      tr {
//        td:nth-child(3) {
//          text-align: left;
//          display: flex;
//        }
//      }
//    }
//  }
//}
/deep/ .table_name {
  table {
    tbody {
      tr {
        td:nth-child(2) .cell {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

///deep/.table_name .cell{
//  display: flex;
//  //align-items: center;
//  //height: 30px;
//  //text-align: center;
//}
.Group-button {
  margin-bottom: 15px;
}

.aside .el-button {
  padding: 0;
}

@media screen and (max-width: 1855px) {
  .biaodan {
    height: 100px;
  }
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}

/deep/ .el-upload__input {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/logManagementOfSys/index.vue